export default "__VITE_ASSET__kFWpHulv__"